import React from "react";

const CallLogs = () => {
  return (
    <div className="flex min-h-[200px] items-center justify-center p-6 text-sm text-gray-600">
      Waiting for an active call...
    </div>
  );
};

export default CallLogs;
